import { Helmet } from "react-helmet-async";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import MonacoEditor from "../../components/MonacoEditor/MonacoEditor";
import { useEffect, useState } from "react";
import { stringToBase64 } from "../../helpers/base64_helper";

const MonacoEditorTeste = () => {
  const [initialValueCSS, setInitialValueCSS] = useState();
  const [editorValueCSS, setEditorValueCSS] = useState("");
  const [initialValueHTML, setInitialValueHTML] = useState();
  const [editorValueHTML, setEditorValueHTML] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setInitialValueCSS(`
body {
  font-family: "Inter", Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  background: #fff;
  margin: 0;
  padding: 20px;
}

h1, h2, h3 {
  font-weight: 600;
  margin-bottom: 8px;
}

a {
  color: #0074d9;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 16px 0;
}

table th, table td {
  padding: 8px;
  border: 1px solid #dcdcdc;
}

table th {
  background: #f3f3f3;
}`);
      setInitialValueHTML(`<p>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vitae
  vestibulum ligula. Vivamus condimentum, sapien id vulputate tincidunt,
  lorem nunc fermentum neque, non dignissim lectus dolor nec nisi.
</p>

<p>
  Nullam in justo lacinia, vestibulum velit sit amet, placerat lectus.
  Etiam id velit elementum, feugiat sapien quis, vulputate purus.
</p>

<ul>
  <li>Lorem ipsum dolor sit amet</li>
  <li>Consectetur adipiscing elit</li>
  <li>Vestibulum condimentum felis vel mauris gravida</li>
</ul>

<p>
  Curabitur ullamcorper, justo vel cursus malesuada, lorem massa vulputate
  ante, ac convallis nisi tellus ut nulla. Donec tristique viverra augue,
  nec aliquet turpis varius non.
</p>`);
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <div className="page-content">
      <Helmet>
        <title>Teste Monaco Editor</title>
      </Helmet>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <Row>
                  <Col xs={12}>
                    <MonacoEditor
                      handleEditorChange={(content) =>
                        setEditorValueHTML(content)
                      }
                      language="html"
                      initialValue={initialValueHTML}
                      loading={loading}
                    />
                  </Col>
                  <Col xs={12} className="my-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        alert(stringToBase64(editorValueHTML));
                      }}
                    >
                      Alert content HTML
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <MonacoEditor
                      handleEditorChange={(content) =>
                        setEditorValueCSS(content)
                      }
                      language="css"
                      initialValue={initialValueCSS}
                      loading={loading}
                    />
                  </Col>
                  <Col xs={12} className="my-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        alert(stringToBase64(editorValueCSS));
                      }}
                    >
                      Alert content CSS
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MonacoEditorTeste;
